var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mb-1", attrs: { dense: "" } },
        _vm._l(_vm.accounts, function (acc) {
          return _c(
            "v-col",
            { key: acc.key, attrs: { cols: "12", sm: "6" } },
            [
              _c(
                "v-card",
                { attrs: { outlined: "" } },
                [
                  _c("v-card-text", { staticClass: "py-3" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _c("div", { staticClass: "text-subtitle-2" }, [
                          _vm._v(_vm._s(acc.label)),
                        ]),
                        _c("v-spacer"),
                        acc.quota && acc.quota.exhausted
                          ? _c(
                              "v-chip",
                              {
                                attrs: { small: "", color: "error", dark: "" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("message.egenmelding.exhausted")
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    acc.quota
                      ? _c("div", { staticClass: "text-body-2 mt-1" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.egenmelding.remaining")) +
                              ": "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(acc.quota.remaining_days)),
                          ]),
                          _vm._v(
                            " / " +
                              _vm._s(acc.quota.max_days) +
                              " " +
                              _vm._s(_vm.$t("message.egenmelding.days")) +
                              " "
                          ),
                          acc.quota.max_instances
                            ? _c("span", [
                                _vm._v(
                                  " · " +
                                    _vm._s(acc.quota.used_instances) +
                                    "/" +
                                    _vm._s(acc.quota.max_instances) +
                                    " " +
                                    _vm._s(
                                      _vm.$t("message.egenmelding.instances")
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _c("v-card-title", { staticClass: "text-subtitle-1" }, [
            _vm._v(_vm._s(_vm.$t("message.egenmelding.report"))),
          ]),
          _c("v-divider"),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.typeItems,
                              "item-text": "text",
                              "item-value": "value",
                              label: _vm.$t("message.egenmelding.type"),
                            },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                value:
                                                  _vm.$formatter.formatDate(
                                                    _vm.form.start_date,
                                                    "YYYY-MM-DD",
                                                    "DD.MM.YYYY"
                                                  ),
                                                label: _vm.$t(
                                                  "message.egenmelding.startDate"
                                                ),
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                rules: [
                                                  function (v) {
                                                    return (
                                                      !!_vm.form.start_date ||
                                                      _vm.$t(
                                                        "message.common.validationIssue"
                                                      )
                                                    )
                                                  },
                                                ],
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.startMenu,
                                callback: function ($$v) {
                                  _vm.startMenu = $$v
                                },
                                expression: "startMenu",
                              },
                            },
                            [
                              _c("v-date-picker", {
                                attrs: { "first-day-of-week": "1" },
                                on: {
                                  input: function ($event) {
                                    _vm.startMenu = false
                                  },
                                },
                                model: {
                                  value: _vm.form.start_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "start_date", $$v)
                                  },
                                  expression: "form.start_date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "number",
                              min: "1",
                              max: _vm.maxDays,
                              label: _vm.$t("message.egenmelding.days"),
                              hint:
                                _vm.form.type === "own"
                                  ? _vm.$t("message.egenmelding.ownDaysHint")
                                  : "",
                              "persistent-hint": "",
                              rules: _vm.daysRules,
                            },
                            model: {
                              value: _vm.form.days,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "days", _vm._n($$v))
                              },
                              expression: "form.days",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    loading: _vm.submitting,
                    disabled: _vm.selectedExhausted,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v(_vm._s(_vm.$t("message.egenmelding.send")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }